<template>
<div class="" id="" style="">
	<header-vue></header-vue>
   <div class="container-l2">
			<h1 class="h11">{{$route.query.device_name}}-{{$route.query.name}}-历史数据</h1>
			<div class="text-center">
				<el-select class="select1" value-key="id" v-model="selectShreId" placeholder="请选择变量">
		          <el-option v-for="item in shreList" :label="item.var_cname" :key="item.id" :value="item.id"></el-option>
		        </el-select>
		        
				<el-date-picker
			      v-model="startdate"
			      dateType="datetime"
			      value-format="timestamp"
			      placeholder="开始日期">
			    </el-date-picker>
			    <el-date-picker
			      v-model="enddate"
			      dateType="datetime"
			      value-format="timestamp"
			      placeholder="结束日期">
			    </el-date-picker>
			    <button class="btn btn-primary" @click="getShrehistory"> 查 看 </button>
			</div>
			<div v-show="ifHasInfo">
				<div class="znjg-box znjg-box3">
					<div class="mt30">
						<div class="echart3" id="echar-jg"></div>
						
					</div>
	
				</div>
			</div>
			
			
		    <div v-if="!ifHasInfo">
				<br />
				<br />
				<br />
				<p class="errorp">该变量该时间段暂无历史数据！</p>
			</div>
			
		
		

   </div>
</div>
</template>

<script>
	import echarts from "echarts/lib/echarts"
	import 'echarts/map/js/china.js';
	export default {
		mounted(){
		  	this.$nextTick(function(){
		  		this.getShresholdList();
		  		//格式化当前时间10天前
				var date2 = new Date();
				var date21 = date2.getTime() - 3600 * 1000 * 24 * 10;
				date2.setTime(date21);
				this.startdate = date2;

				this.getShrehistory();
		  		
		  	})
		  	
		},
		data() {
		  	return {
		  		sysInfo:[],
		  		ifHasInfo:true,
		  		info:'',
       			startdate:new Date(),
       			enddate:new Date(),
		  		dialogFormVisible:false,
		  		drawInfo:{},
		  		shreList:[],
		  		selectShreId:null,
		  		record:[],
		  		varunit:""
		  	}
		},
		methods:{
//			获取设备变量列表
			getShresholdList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					mount_device_id:this.$route.query.id,
					token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountRecord/MountVariableList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.shreList = res.data.data;
		        		if(this.shreList[0]){
		        			this.selectShreId = this.shreList[0].id;
		        			this.getShrehistory();
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
		      
			//获取历史数据
			getShrehistory() {
				this.ifHasInfo = true;
				let sysInfoParams={
		  			uid:this.getCookie('uid'),
		  			mount_device_id:this.$route.query.id,
		  			mount_var_id:this.selectShreId,
		  			starttime:parseInt(this.startdate/1000),
		  			endtime:parseInt(this.enddate/1000),
		  			token:this.getCookie('token'),
		  			time:Date.parse( new Date()),
		  			terminalId:4,
		  		};	
		  		this.sign2(sysInfoParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountRecord/MountDeviceRecord",this.$qs.stringify(sysInfoParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 && res.data.data){
		        		if(res.data.data[0]){
		        			this.varunit = res.data.data[0].var_unit;
		        			this.record = res.data.data[0].record;
		        			if(this.record.time && this.record.time.length>0){
		        				this.drawLine();
		        			}else{
		        				this.ifHasInfo = false;
		        			}
		        			
		        		}
		        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  			
		  		});
		  		
		  		
			},



			drawLine(){
				let chartJg = this.$echarts.init(document.getElementById('echar-jg'));
		    	chartJg.setOption({
					title : {
				        text: '历史数据图表',
				        x:'left',
				        textStyle:{
				        	color:'#aaa'
				        }
				    },
				    tooltip : {
				        trigger: 'axis',
				        formatter: "历史数据 <br/>{b} : {c}（"+this.varunit+"）",
				        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
				            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
				        }
				    },
				    grid: {
				    	top:"15%",
				        left: '3%',
				        right: '4%',
				        bottom: '10%',
				        containLabel: true
				    },
				    
				    xAxis : [
				        {
				            type : 'category',
				            data : this.record.time || [],
				            axisTick: {
				                alignWithLabel: true
				            },
				            axisLabel:{
				            	textStyle:{
						        	color:'#aaa'
						        }
				            },
				            axisLine: {
				                lineStyle: {
				                    color: '#aaa'
				                }
				            },
				            
				        }
				    ],
				    yAxis : [
				        {
				            type : 'value',
				            axisLine: {
				                lineStyle: {
				                    color: '#aaa'
				                }
				            },
				        }
				    ],
				    series : [
				        {
				            name:'所选区域告警统计图',
				            type:'line',
				            barWidth: '60%',
				            itemStyle: {
				                normal: {
				                    color: '#55be2c'
				                }
				            },
				            data:this.record.mount_value || []
				        }
				    ]
				},true);
			},
		
		}
	}
	
</script>

<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/device/dataCenterDetail.vue